/* eslint-disable @next/next/no-html-link-for-pages */
import { Dispatch, Fragment, useEffect } from 'react'
import { SearchProductItem } from '../SearchProductItem'
import Link from 'next/link'
import { Loading } from '../../Loading'
import { Empty } from 'antd'
import { getSearchResult } from '~src/api/product'
import { useQuery } from 'react-query'
import useDebounce from '~src/hook/useDebounce'

type TSearchResultProps = {
  searchValue: string
  setSearchValue: Dispatch<React.SetStateAction<string>>
}

export const SearchResult: React.FC<TSearchResultProps> = ({ searchValue, setSearchValue }) => {
  const debouncedSearchValue = useDebounce(searchValue, 500)

  const { data: dataResultSearch, isLoading } = useQuery(
    ['SEARCH-RESULT', debouncedSearchValue],
    () =>
      getSearchResult({
        q: debouncedSearchValue,
        page: 1,
        pageSize: 10,
      }).then((res: any) => {
        return res
      })
    // {
    //   enabled: !!debouncedSearchValue,
    // }
  )

  if (isLoading) {
    return (
      <div className="absolute top-[130%] left-0 transition-all duration-300 z-[2] rounded-[0.6rem] w-full min-h-[40vh] bg-white overflow-hidden">
        <div className="absolute flex items-center justify-center h-full w-full">
          <Loading />
        </div>
      </div>
    )
  }

  if (dataResultSearch?.items?.length <= 0) {
    return (
      <div className="absolute top-[130%] left-0 transition-all duration-300 z-[2] rounded-[0.6rem] w-full min-h-[40vh] bg-white overflow-hidden">
        <div className="flex items-center justify-center h-full absolute w-full">
          <Empty
            description={
              <p className="font-semibold text-[1.6rem] sm:text-[1.4rem] ">
                Không tìm thấy kết quả nào
              </p>
            }
          />
        </div>
      </div>
    )
  }

  return (
    <div className="absolute top-[130%] left-0 transition-all duration-300 z-[2] rounded-[0.6rem] w-full max-h-[40vh] min-h-[30vh] bg-white">
      <div className="flex flex-col max-h-inherit min-h-inherit min-h-[30vh]">
        <div className="flex-1 overscroll-contain max-h-[30vh] overflow-x-hidden overflow-y-auto">
          {dataResultSearch?.items?.map((item: any, index: number) => (
            <Fragment key={item?.id}>
              <SearchProductItem product={item} />
              {dataResultSearch?.items?.length - 1 !== index && (
                <hr className="mx-[1rem] sm:mx-[4rem] text-[#f2f2f2]" />
              )}
            </Fragment>
          ))}
        </div>
        <Link href="/product" legacyBehavior>
          <a
            href="/product"
            className="bg-[#239f40] sticky rounded-bl-[0.6rem] rounded-br-[0.6rem] bottom-[0] block hover:bg-[#1f8a38] hover:text-white transition-all duration-300 text-[white] font-semibold cursor-pointer border-t border-solid border-[#e5e7eb] py-6 text-center leading-[100%]"
          >
            Xem tất cả sản phẩm
          </a>
        </Link>
      </div>
    </div>
  )
}
